import { useState } from 'react';
import axios from 'axios';
import { MailWarning, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VerificationBanner = () => {
    const { user } = useAuth();
    const [sending, setSending] = useState(false);

    // Only show for signed-in users whose email is explicitly unverified.
    if (!user || user.is_verified !== false) return null;

    const resend = async () => {
        setSending(true);
        try {
            await axios.post(`${API}/auth/resend-verification`, {}, { withCredentials: true });
            toast.success('Verification email sent. Please check your inbox.');
        } catch (e) {
            toast.error('Could not send verification email. Please try again.');
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="bg-amber-50 border-b border-amber-200" data-testid="verification-banner">
            <div className="container-main py-3 flex flex-col sm:flex-row items-center justify-between gap-2">
                <div className="flex items-center gap-2 text-amber-800 text-sm">
                    <MailWarning className="w-4 h-4 shrink-0" />
                    <span>Please verify your email address to secure your account.</span>
                </div>
                <button
                    onClick={resend}
                    disabled={sending}
                    className="text-sm font-semibold text-amber-900 underline underline-offset-2 flex items-center gap-1 disabled:opacity-60"
                    data-testid="resend-verification-btn"
                >
                    {sending && <Loader2 className="w-3 h-3 animate-spin" />}
                    Resend email
                </button>
            </div>
        </div>
    );
};
